// src/components/Navbar.js

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom'; // Import NavLink from react-router-dom
import TopLogo from '../images/channels4_profile.jpg';
import OpenIcon from '../images/mobileNav.png';
import CloseIcon from '../images/closeIcon.png';

const TopNavbar = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	return (
		<div className='bg-white'>
			{/* Desktop nav  */}
			<nav className='lg:block hidden bg-white text-[#4aa39c] mt-[33px] mx-[156px] lg:h-[101px]'>
				<div className='container mx-auto flex  items-center'>
					<a href='/' className='text-2xl font-bold lg:w-[113px]'>
						<img src={TopLogo} />
					</a>
					{/* Navigation links */}
					<ul className={`lg:flex space-x-8 lg:block`}>
						<li>
							<NavLink
								to='/'
								className={({ isActive }) =>
									isActive
										? 'text-[#4aa39c] font-bold'
										: 'hover:text-[#4aa39c]'
								}
							>
								Home
							</NavLink>
						</li>
					</ul>
				</div>
			</nav>
			{/* Mobile nav */}
			<div className='relative lg:hidden w-full'>
				<div className='lg:hidden flex justify-between'>
					{/* Hamburger menu for small screens */}
					<img src={TopLogo} className='w-[82px] h-[60px] ml-[20px]' />
				</div>
			</div>
		</div>
	);
};

export default TopNavbar;
